export default "__VITE_ASSET__C56Hv6fy__"